import React, { Suspense } from "react";
import { Box, Flex } from "@chakra-ui/react";
import SettlementManagementCalendar from "@/features/my-order/features/settlement-management/components/fee/SettlementManagementCalendar";
import SettlementManagementBillingHistoryList from "@/features/my-order/features/settlement-management/components/fee/SettlementManagementBillingHistoryList";
import SettlementManagementTooltipHeader from "@/features/my-order/features/settlement-management/components/fee/SettlementManagementTooltipHeader";
import SettlementManagementSummary from "@/features/my-order/features/settlement-management/components/fee/SettlementManagementSummary";
import SettlementManagementIBillingDetail from "@/features/my-order/features/settlement-management/components/fee/SettlementManagementIBillingDetail";
import useSettlementManagementQuery from "@/features/my-order/features/settlement-management/hooks/useSettlementManagementQuery";
import CenteredSpinner from "@/shared/components/centered-spinner";
import useGetUnoFeeList from "@/features/my-order/features/settlement-management/hooks/query/useGetUnoFeeList";
import { UnoFee } from "@/features/my-order/features/settlement-management/types";
import { format } from "date-fns";

function SettlementManagementFeeContent() {
  return (
    <Suspense fallback={<CenteredSpinner />}>
      <Flex padding={"16px"} gap={"16px"} paddingBottom={"32px"}>
        <Box flex={1} minWidth={"656px"}>
          <SettlementManagementCalendar />
        </Box>
        <Flex width={"480px"} flexDirection={"column"} gap={"16px"}>
          <InfoMainSection />
        </Flex>
      </Flex>
    </Suspense>
  );
}

export default SettlementManagementFeeContent;

const InfoMainSection = () => {
  const { query } = useSettlementManagementQuery();
  const isDateSelected = query.unoFeeId;
  const currentDate = query.date ? new Date(query.date) : new Date();

  const params = {
    settlement_month__eq: format(currentDate, "yyyy-MM"),
  };
  const { data } = useGetUnoFeeList(params);
  const selectedBilling =
    isDateSelected && data?.unoFees.find((fee) => fee.id === query.unoFeeId);

  return (
    <>
      <SettlementManagementTooltipHeader />
      <SettlementManagementSummary statistics={data?.statistics} />
      {!isDateSelected || !selectedBilling ? (
        <Flex flexDirection={"column"} gap={"16px"}>
          <SettlementManagementBillingHistoryList unoFeeList={data?.unoFees} />
        </Flex>
      ) : (
        <SettlementManagementIBillingDetail unoFee={selectedBilling} />
      )}
    </>
  );
};
